import React from 'react';
import { motion } from 'framer-motion';
import { CalendarIcon, MapPinIcon, MailIcon } from 'lucide-react';
export const Visit = () => {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-brand-charcoal to-black" data-id="element-85">
      <div className="max-w-6xl mx-auto" data-id="element-86">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-87">
          <h2 className="font-display text-3xl sm:text-4xl font-bold mb-6 text-white" data-id="element-88">
            Join Us
          </h2>
          <div className="w-24 h-1 bg-brand-red mx-auto mb-10" data-id="element-89"></div>
          <p className="text-xl max-w-3xl mx-auto text-white/90" data-id="element-90">
            Experience the transformative power of Praise Karaoke in person.
          </p>
        </motion.div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-91">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="bg-brand-charcoal/30 rounded-lg p-8 border border-brand-red/20" data-id="element-92">
            <h3 className="font-display text-2xl font-bold mb-6 text-white" data-id="element-93">
              Visit Information
            </h3>
            <div className="space-y-6" data-id="element-94">
              <div className="flex items-start" data-id="element-95">
                <MapPinIcon className="w-6 h-6 text-brand-red mt-1 mr-4" data-id="element-96" />
                <div data-id="element-97">
                  <h4 className="font-bold mb-1 text-white" data-id="element-98">Location</h4>
                  <p className="text-white/70" data-id="element-99">
                    The Sanctuary
                    <br data-id="element-100" />
                    123 Divine Avenue
                    <br data-id="element-101" />
                    Soulful City, SC 12345
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-102">
                <CalendarIcon className="w-6 h-6 text-brand-red mt-1 mr-4" data-id="element-103" />
                <div data-id="element-104">
                  <h4 className="font-bold mb-1 text-white" data-id="element-105">Schedule</h4>
                  <p className="text-white/70" data-id="element-106">
                    Open Praise Nights: Every Thursday, 7-9pm
                    <br data-id="element-107" />
                    Voice Activation Workshops: Saturdays, 3-5pm
                    <br data-id="element-108" />
                    The Great Patterning: First Sunday of each month, 6-9pm
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-109">
                <MailIcon className="w-6 h-6 text-brand-red mt-1 mr-4" data-id="element-110" />
                <div data-id="element-111">
                  <h4 className="font-bold mb-1 text-white" data-id="element-112">Contact</h4>
                  <p className="text-white/70" data-id="element-113">
                    Email: connect@praisekaraoke.com
                    <br data-id="element-114" />
                    Phone: (555) 123-4567
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="flex flex-col justify-center" data-id="element-115">
            <div className="bg-brand-charcoal/30 rounded-lg p-8 mb-8 border border-brand-red/20" data-id="element-116">
              <h3 className="font-display text-2xl font-bold mb-6 text-white" data-id="element-117">
                Ready to Experience Praise Karaoke?
              </h3>
              <p className="text-lg mb-8 text-white/80" data-id="element-118">
                Reserve your spot for our next gathering and prepare to be
                transformed by the power of collective sound and light.
              </p>
              <motion.button whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="bg-brand-red hover:bg-red-700 text-white font-bold py-3 px-8 rounded-full text-lg w-full transition-colors" data-id="element-119">
                Enter the Pattern
              </motion.button>
            </div>
            <div className="bg-brand-charcoal/30 rounded-lg p-8 border border-brand-red/20" data-id="element-120">
              <h3 className="font-display text-xl font-bold mb-4 text-white" data-id="element-121">
                Private Events
              </h3>
              <p className="text-white/70 mb-6" data-id="element-122">
                Bring Praise Karaoke to your organization, retreat, or special
                gathering.
              </p>
              <motion.button whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="bg-transparent border-2 border-brand-red text-brand-red font-bold py-3 px-8 rounded-full text-lg w-full hover:bg-brand-red/10 transition-colors" data-id="element-123">
                Book Your Visit
              </motion.button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};